import styled, { css } from 'styled-components';

export const ItemWrapper = styled.div<{ isLoading: boolean }>`
  width: 100%;
  ${({ theme, isLoading }) => css`
    cursor: pointer;

    :hover {
      background-color: ${theme.color.background.neutral.weak};
      border-radius: ${theme.border.radius.medium};
    }

    ${isLoading &&
    css`
      cursor: wait;
    `}
  `};
`;

export const CursorWrapper = styled.div<{ isLoading: boolean }>`
  ${({ theme, isLoading }) => css`
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.spacing.km2};
    padding: ${theme.spacing.km2};

    ${isLoading &&
    css`
      pointer-events: none;
    `}
  `};
`;
